import { render } from "./cpt-img-quota-tips-option.vue?vue&type=template&id=b5d7d62c"
import script from "./cpt-img-quota-tips-option.vue?vue&type=script&lang=js"
export * from "./cpt-img-quota-tips-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__